export const CERTIFICATE_PROFILE = {
  name: 'Madanjit Singh Deva',
  company: 'NZ Plumbing Limited',
  registrationNo: '29212',
  address: '74A Hillcrest Road, Papatoetoe, Auckland.',
  postcode: '2025',
  business: '',
  fax: '',
  mobile: '021 793 081',
  email: 'info@nzplumbing.nz'
} as const;

export function defaultCertificateContact() {
  return {
    address: CERTIFICATE_PROFILE.address,
    postcode: CERTIFICATE_PROFILE.postcode,
    business: CERTIFICATE_PROFILE.business,
    fax: CERTIFICATE_PROFILE.fax,
    mobile: CERTIFICATE_PROFILE.mobile,
    email: CERTIFICATE_PROFILE.email
  };
}
